import { GridColDef, GridRenderCellParams, GridRowId, GridValueGetterParams } from "@mui/x-data-grid";
import DeleteIcon from '@mui/icons-material/Delete';
import { Link } from "@mui/material";
import i18next from "i18next";

interface Props {
  onDelete: (id: GridRowId) => void;
  onUndo: (idd: GridRowId) => void;
  isDeleted: (id: GridRowId) => boolean;
}

export const SearchResultColumn = ({ onDelete, onUndo, isDeleted }: Props): GridColDef[] => [

  { field: 'id', headerName: '', flex: 0.2, renderCell:(index) => index.api.getRowIndex(index.row.id) + 1},
  { field: 'personnelNumber', headerName: i18next.t('PersonnelNumberText'), flex: 0.8},
  { field: 'name', headerName: i18next.t('FullNameText'), flex: 1.2},
  { field: 'jobTitle', headerName: i18next.t('JobTitleText'), flex: 1.2},
  { field: 'isActive', headerName: i18next.t('StatusText'), flex: 0.6, valueGetter: (params: GridValueGetterParams) =>
    params.row.isActive ? i18next.t('GenericActiveText') : i18next.t('GenericInactiveText')
  },
  { field: 'userType', headerName: i18next.t('GenericTypeText'), flex: 0.6},
  { field: 'PLMAccess', headerName: i18next.t('PlmAccessText'), flex: 0.8, valueGetter: (params: GridValueGetterParams) =>
    params.row.plmAccess ? i18next.t('GenericYesText') : i18next.t('GenericNoText')
  },
  {
    field: 'deleteButton',
    headerName: '',
    filterable: false,
    width: 80,    
    renderCell: (params: GridRenderCellParams) => {
      const handleDeleteClick = () => {
        if (onDelete) {
          onDelete(params.id as GridRowId);
        }
      };
      const handleUndoClick = () => {
        onUndo(params.id as GridRowId);
      };

      return isDeleted(params.id as GridRowId) ?
      (
        <Link
          onClick={handleUndoClick}
        >
          {i18next.t('GenericUndoText')}
        </Link>
      ): 
      (
        <DeleteIcon color="action" onClick={handleDeleteClick} />
      );
    }
  }
];
